import * as Scroll from 'react-scroll';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

import logo from './images/logo.svg';
import Casey from "./images/casey-face.png";
import DownArrow from "./images/down-arrow.svg";
import NavBar from "./components/navbar";
import About from "./views/about";
import Work from "./views/work";
import Design from "./views/design";
import Contact from "./views/contact";
import Footer from "./components/footer";
import Lines from "./images/lines.svg";

import './css/app.css';

function App() {
  return (
    <div>
      <img className="lines-art-right" src={Lines}/>
      <NavBar/>
      <div className="header-section align-items-center d-flex flex-md-row flex-column-reverse justify-content-between mt-5 pt-5 container mb-5">
        <div className="flex-4 me-4">
          <h1>Casey Alvarez</h1>
          <h3 className="text-dark">software engineer</h3>
          <p className="my-4">Tech enthusiast and creative software engineer with a knack for designing and developing innovative solutions. Proficient in multiple programming languages and frameworks, I thrive on delivering efficient, scalable, and robust code. With a passion for technology and a collaborative mindset, I excel in driving projects from concept to completion, bringing a dynamic energy to every team I work with.
          </p>
        </div>
        <img src={Casey} className="main-headshot flex-1"/>
      </div>
      <Link  to="about" delay={0} smooth={false} offset={0}  duration={500}>
        <div className="text-center">
          <p className="pointer text-center mb-0">scroll</p>
          <img className="pointer scroll-arrow"src={DownArrow}/>
        </div>
      </Link>
      <About/>
      {process.env.NODE_ENV === "development" ? (
        <>
          <Work/>
          <div className="divider mt-5"></div>
        </>
      ): null}
      
      <Design/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
